import { axiosBitrixInstance } from "../../utils/axios/requestInfo";
import { generateGuid } from "../../helpers/generateGuid";
import { getMoscowDate } from "../../helpers/dateFormatter";
import { api } from "../../resources/api";

export type ItemType = 'rent' | 'membership';
export type MembershipType = 'adult' | 'kid' | 'gift' | 'family';

export interface IPaymentItem {
  itemType: ItemType;
  courtId?: string;
  sum?: number;
  startTime?: string;
  finishTime?: string;
  membershipType?: MembershipType;
  membershipId?: string;
  count?: number;
  profileName?: string;
  partnerId?: string;
  phone?: string;
  birthday?: string;
  giftDate?: string;
  email?: string;
  message?: string;
  additionalOwners?: Array<{ partnerId: string }>;
}

export interface IPaymentObject {
  partnerId: string;
  guid: string;
  changeDate: string;
  items: IPaymentItem[];
  paymentId: string;
}

export interface IWaitingPaymentParams {
  paymentObject: IPaymentObject;
  paymentId: string;
}

export interface ICreatePaymentParams {
  partnerId: string;
  guid: string;
  changeDate: string;
  items: IPaymentItem[];
  paymentId: string;
}

export const sendBitrixPrepaymentInfo = async (
  params: IWaitingPaymentParams
): Promise<any> => {
  try {
    const prepaymentGuid = generateGuid({
      phone: params.paymentObject.partnerId,
      name: params.paymentId,
      email: new Date().toISOString(),
    });

    const paymentObjectString = JSON.stringify(params.paymentObject);

    const response = await axiosBitrixInstance.post(
      api.bitrix.WAITING_PAYMENT,
      {
        paymentObject: paymentObjectString,
        paymentId: params.paymentId,
        guid: prepaymentGuid,
      }
    );

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const bitrixPaymentObjectSend = async (
  params: ICreatePaymentParams
): Promise<any> => {
  try {
    const response = await axiosBitrixInstance.post(
      api.bitrix.CREATE_PAYMENT,
      {
        partnerId: params.partnerId,
        guid: params.guid,
        changeDate: params.changeDate,
        items: params.items,
        paymentId: params.paymentId,
      }
    );

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const createPaymentObject = (
  partnerId: string,
  paymentId: string,
  items: IPaymentItem[]
): IPaymentObject => {
  const guid = generateGuid({
    phone: partnerId,
    name: paymentId,
    email: new Date().toISOString(),
  });

  return {
    partnerId,
    guid,
    changeDate: getMoscowDate(),
    items,
    paymentId,
  };
};

